import React from 'react';

function ReferentAppointmentsTutorial() {
  return (
    <div className="space-y-4 text-sm">
      <p>
        Ce module permet de <b>gérer un appel entrant</b> et de <b>fixer un rendez-vous</b> en assignant
        un collaborateur disponible. La version actuelle est <b>mockée</b> pour valider le parcours et l’interface.
      </p>
      <ol className="ml-5 list-outside list-decimal space-y-2 pl-5" style={{ listStyle: 'decimal' }}>
        <li>Renseignez les informations du contact et du bien.</li>
        <li>Choisissez le type de demande (Vente/Location) pour afficher l’équipe correspondante.</li>
        <li>Sélectionnez un collaborateur disponible.</li>
        <li>Choisissez une date et une heure, puis confirmez le rendez-vous.</li>
        <li>Dans la liste des RDV, vous pourrez simuler l’envoi d’emails.</li>
      </ol>
      <p className="text-slate-600">Les données sont locales et non persistées côté serveur.</p>
    </div>
  );
}

export default ReferentAppointmentsTutorial;


